import { Component, Watch } from 'vue-property-decorator';
import { faCheck, faCircleNotch, faTimes } from "@fortawesome/free-solid-svg-icons"

import { ItemTypeWrapper, Wemi, getTranslatedString } from '@skinsoft/types';
import { futureLocation } from '@skinsoft/search-data-store/src/search-result-selectors';
import { LocationDataStore } from '@skinsoft/entity';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { ItemCard, SearchResultItemCard } from '@skinsoft/ui';


@Component({
    components: {
        sSearchResultItemCard: SearchResultItemCard,
        sItemCard: ItemCard,
    },
    props: ['item', 'canDelete'],
    template: require('./container-item-card.html')
})
export class ContainerItemCard extends ReactiveVue {
    private item: ItemTypeWrapper;
    private canDelete: boolean

    private futureLocation: string = ''
    private deleting: boolean = false
    private isBeingDeletedId: string = '' // when item changes the component is not recreated and keep old values
                                           // sometimes the change event is triggered when the item is still the same
                                           // so we keep id of the item in isBeingDeleted state to know if we keep or not the state

    private $locationDataStore: LocationDataStore

    public checkIcon = faCheck
    public crossIcon = faTimes
    public spinnerIcon = faCircleNotch

    private mounted() {
        this.getFutureLocation()
    }

    private get isBeingDeleted() {
        if(this.item.item && this.isBeingDeletedId) {
            let id = (this.item.item as any).id ? (this.item.item as any).id : (this.item.item as Wemi).item?.id
    
            return this.isBeingDeletedId === id
        }

        return false
    }

    private set isBeingDeleted(value: boolean) {
        if(value) {
            let id = (this.item.item as any).id ? (this.item.item as any).id : (this.item.item as Wemi).item?.id
            this.isBeingDeletedId = id
        } else {
            this.isBeingDeletedId = ''
        }
    }

    private getFutureLocation() {
        if(this.item) {
            // @ts-ignore
            const location = futureLocation(this.item.item)
            if(location) {
                this.futureLocation = getTranslatedString(location.path, this.$i18n.locale)
            } else {
                this.futureLocation = ''
            }
        }
    }

    private onLongPress() {
        if(this.canDelete) {
            this.isBeingDeleted = !this.isBeingDeleted
        }
    }

    private onDelete() {
        this.deleting=true
        this.$emit('delete', this.item)
    }

    private onCancelDelete() {
        this.isBeingDeleted = false
    }

    @Watch('item', { immediate: true, deep: true })
    private onItemChange() {
        if (this.item?.item) {
            this.getFutureLocation()
        }
    }
}